import React, { useState } from "react";
import { FaPlusCircle, FaTimesCircle, FaMinusCircle } from "react-icons/fa";
import { styles } from "../annonceDetaille";
import { useTranslation } from "react-i18next";

function Exigence({ exigences, setExigences }) {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");
  const { t } = useTranslation();

  const ajouterItem = () => {
    if (!input.trim()) return setError("L'exigence ne peut pas être vide.");
    if (input.trim().length < 3)
      return setError("Au moins 3 caractères requis.");
    if (exigences.length >= 3) return setError("Maximum 3 exigences.");
    setExigences([...exigences, input.trim()]);
    setInput("");
    setError("");
  };
  const enleverItem = (i) =>
    setExigences(exigences.filter((_, idx) => idx !== i));

  return (
    <div>
      <label>{t("editAd.requirementsLabel")}</label>
      <div className="d-flex">
        <input
          type="text"
          className="form-control"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <FaPlusCircle
          className="ms-2 align-self-center"
          size={24}
          onClick={ajouterItem}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div
        style={{
          marginLeft: 20,
          marginTop: 10,
          marginBottom: 20,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h6>{t("editAd.requirementHelp1")}</h6>
        <h6>{t("editAd.requirementHelp2")}</h6>
      </div>
      {error && <p className="text-danger">{error}</p>}
      <ul className="mt-2">
        {exigences.map((item, i) => (
          <li key={i} className="d-flex justify-content-between">
            {item}
            <FaTimesCircle
              className="text-danger"
              style={{ cursor: "pointer" }}
              onClick={() => enleverItem(i)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Exigence;
